module.exports = __webpack_public_path__ + "static/chunks/src/page-home/part-why-replace/assets/image-cause-03.88c23b3ee4d94e069044bce469247f4b.webp";